import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  IconButton,
  Drawer,
  Button,
  Divider,
  Snackbar,
} from "@material-ui/core";
import DescriptionIcon from '@material-ui/icons/Description';
import FolderIcon from '@material-ui/icons/Folder';
import InfoIcon from '@material-ui/icons/Info';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import SyncIcon from '@material-ui/icons/Sync';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from 'ag-grid-react';
import SearchBar from "material-ui-search-bar";
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import {
  GetOrdersProductAsync,
  getRemissionDetailAsync,
  getRemissionsByOrderAsync,
  getWarehouseAsync,
  getLocationsAsync
} from "../../actions/userActions";
import {
  getAllOrders
} from "../../actions/userActions2";
import { useNavbar } from "../../components/layouts/layout1/navbar/NavbarComponent";
import { SubNavBarComponent } from '../../components/layouts/layout1/subnavbar/SubNavBarComponent';
import { AG_GRID_LOCALE_ES } from "../../utils/AgGridSpanish";
import './sass/styles.scss';
import { param } from "jquery";
import CropFreeIcon from '@material-ui/icons/CropFree';
import MuiAlert from '@material-ui/lab/Alert';
import { Autocomplete } from "@material-ui/lab";

const OrderListOrders = (props) => {

  const history = useHistory();
  const requestH = useSelector((state) => state.user.request);

  const [openToasty, setOpenToasty] = React.useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const gridRef = useRef();
  const pagination = true;
  const paginationPageSize = 5;
  const paginationPageSizeSelector = [5, 10, 20, 50, 100];

  const columns = [
    {
      colId: 'tipo',
      field: 'tipo',
      headerName: 'Tipo',
      sortable: false,
      cellRenderer: customType,
      headerComponent: customTypeHeader,
      maxWidth: 80,
      minWidth: 80,
      headerStyle: { textAlign: "center" },
      cellStyle: { textAlign: "center" }
    },
    {
      colId: 'id',
      field: 'id',
      headerName: 'Folio',
      maxWidth: 100,
      minWidth: 100,
      autoHeight: true,
      cellRenderer: customFolio,
      cellStyle: { textAlign: "center" }
    },
    {
      field: 'quotation.currentDate',
      headerName: 'Fecha Pedido',
      sortable: true,
      type: 'date',
      cellStyle: { textAlign: "center" },
      getQuickFilterText: params => {
        return params.data.quotation.currentDate;
      }
    },
    {
      field: 'quotation.deliveryDate',
      headerName: 'Fecha Requerida',
      type: 'date',
      sortable: true,
      cellRenderer: customFechaRequerida,
      cellStyle: { textAlign: "center" },
      getQuickFilterText: params => {
        return params.data.quotation.deliveryDate;
      }
    },
    {
      field: 'dinVariable2',
      headerName: 'Cliente',
      sortable: true,
      wrapText: true,
      autoHeight: true,
      cellRenderer: customCliente
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 200,
      cellRenderer: customStatus,
      cellStyle: { textAlign: "center" },
      sortable: false
    },
    {
      field: 'dinNumeric',
      headerName: 'Proceso',
      maxWidth: 120,
      minWidth: 120,
      cellRenderer: customProcess,
      cellStyle: { textAlign: "center" },
      sortable: false
    },
    {
      field: 'dinNumeric2',
      headerName: '# Envios',
      cellRenderer: customShipment,
      cellStyle: { textAlign: "center" }
    }
  ]

  const columnTypes = useMemo(() => {
    return {
      date: {
        valueFormatter: formatearFecha,
      }
    };
  }, []);

  const autoSizeStrategy = {
    type: 'fitGridWidth',
    defaultMinWidth: 100,
  };

  function customTypeHeader(data) {
    return (
      <div style={{ alignItems: 'center', display: 'flex' }}>
        <Tooltip
          visible={tooltipVisible}
          placement="right"
          animation="zoom"
          onVisibleChange={changeTooltipVisible}
          trigger="click"
          overlay={
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}><ShoppingBasketIcon style={{ marginRight: 4 }} />Pedido de Venta</div>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}><FolderIcon style={{ marginRight: 4 }} />Reporte de Consumo</div>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}><DescriptionIcon style={{ marginRight: 4 }} />Prestamo</div>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}><SyncIcon style={{ marginRight: 4 }} />Consigna</div>
            </div>
          }
        >
          <InfoIcon onClick={changeTooltipVisible} style={{ color: '#484f59' }} />
        </Tooltip>
        {data.displayName} {/* Muestra el nombre de la columna */}
      </div>
    );
  }

  function customFolio(data) {
    return (
      <p onClick={() => { handleGetAllInfo([data.data]) }} style={{ color: 'black', fontWeight: 'bold', textDecoration: 'underline' }}>{data.value}</p>
    )
  }
  function customCliente(data) {
    return (
      <p onClick={() => { handleGetAllInfo([data.data]) }} style={{ color: 'black', fontWeight: 'bold', textDecoration: 'underline' }}>{data.value}</p>
    )
  }
  /* Definir cual campo va a ser el de la fecha requerida */
  function customFechaRequerida(data) {
    const date = formatearFecha(data)
    const overdue = isOverdue(data)

    return (
      <p style={{
        color: overdue ? 'red' : 'black'
      }}>{date}</p>
    )
  }
  /* Definir cual campo va a ser el del tipo */
  function customType(data) {
    return (
      <div style={{
        marginTop: 8
      }}>
        <ShoppingBasketIcon style={{ color: '#484f59' }} />
      </div>
    )
  }
  /* Definir si el status va a venir del servicio o hacer el calculo aqui */
  function customStatus(data) {
    /* const informationStatus = getInfoOfAll(data.data.id) */
    const status = data.data.dinNumeric

    const statusColor = (status > 0 && status < 100) ? 'rgba(11, 71, 116,1)' : (status > 99) ? 'rgba(93, 126, 64,1)' : 'rgba(177, 67, 67,1)'
    const statusText = (status > 99) ? 'Surtido' : (status > 0 && status < 100) ? 'Parcialmente \nSurtido' : 'Sin proceso'
    return (
      <p style={{ color: statusColor, fontWeight: 'bold', whiteSpace: 'pre-line' }}>{statusText}</p>
    )
  }
  /* Definir si el process va a venir del servicio o hacer el calculo aqui */
  function customProcess(data) {
    return (
      <p style={{
        color: '#ec6010',
        fontWeight: 'bold'
      }}>{data.value || '0'}%</p>
    )
  }
  /* Definir si el shipment va a venir del servicio o hacer el calculo aqui */
  function customShipment(data) {
    return (
      <p>{data.value || 0}</p>
    )
  }
  function isOverdue(data) {
    if (data && data.value) {
      const fecha = new Date(data.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to midnight to compare only dates

      return fecha <= today;
    }
    return false;
  }
  function formatearFecha(data) {
    if (data && data.value) {
      const fecha = new Date(data.value);

      const formatter = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      let fechaFinal = formatter.format(fecha).replace(" de ", "/").replace(" de ", "/");
      return fechaFinal;
    }
  }

  function formatArray(arr) {
    return arr.map((item) => {
      const details = item.details.flat();
      const shipmentsQuantity = details.length;

      let generalQuantity = 0;
      details.forEach((detail) => {
        generalQuantity += detail.quantity;
      });

      return {
        ...item,
        details,
        shipmentsQuantity,
        generalQuantity
      };
    });
  }

  function returnRemissionsArray(cadena) {
    const numeros = cadena.split(',').map(item => parseInt(item.trim()));
    return numeros;
  }

  const handleGetAllInfo = async (orders) => {
    props.setLoading(true)
    let ordersRemissions = []
    for (const element of orders) {
      await getRemissionsByOrderAsync(element.id, requestH).then(async (data) => {
        if (data.response && data.response.length > 0 && data.response[0].remissions) {
          const remissionData = data.response[0]
          const arrayRemissions = returnRemissionsArray(data.response[0].remissions)
          if (arrayRemissions && arrayRemissions.length > 0) {
            const allRemissionsDetail = []
            for (const singleRemission of arrayRemissions) {
              /* await getRemissionDetailAsync(singleRemission, requestH).then((dataDetail) => {
                allRemissionsDetail.push(dataDetail.response)
              }) */
            }
            remissionData.details = allRemissionsDetail
            remissionData.orderId = element.id
            ordersRemissions.push(remissionData)
          }
        }
      })
    }
    props.setLoading(false)
    history.push({
      pathname: "/orderDetailsNew",
      state: {
        order: orders[0],
        remissionInformation: formatArray(ordersRemissions)[0]
      }
    });
  }

  function changeTooltipVisible() {
    setTooltipVisible(!tooltipVisible)
  }

  return (
    <div style={{ height: '85%' }}>
      <div className="ag-theme-quartz" style={{ height: '95%', margin: 10 }}>
        {!props.loading &&
          <AgGridReact
            ref={gridRef}
            rowData={props.orders}
            localeText={AG_GRID_LOCALE_ES}
            columnDefs={columns}
            suppressMovableColumns
            columnTypes={columnTypes}
            rowHeight={80}
            autoSizeStrategy={autoSizeStrategy}
            pagination={pagination}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
            quickFilterText={props.searchedValuesGeneral}
          />
        }
      </div>
    </div>
  )
}

const OrderListProducts = (props) => {

  const history = useHistory();
  const requestH = useSelector((state) => state.user.request);

  const [tooltipVisible, setTooltipVisible] = useState(false);

  const gridRef = useRef();

  const pagination = true;
  const paginationPageSize = 5;
  const paginationPageSizeSelector = [5, 10, 20, 50, 100];

  const columns = [
    {
      colId: 'tipo',
      field: 'tipo',
      headerName: 'Tipo',
      sortable: false,
      cellRenderer: customType,
      headerComponent: customTypeHeader,
      maxWidth: 75,
      minWidth: 75,
      headerStyle: { textAlign: "center" },
      cellStyle: { textAlign: "center" }
    },
    {
      colId: 'code',
      field: 'dinVariable2',
      headerName: 'ProdCode',
      autoHeight: true,
      cellRenderer: customProdCode,
      cellStyle: { textAlign: "center" }
    },
    {
      field: 'dinVariable',
      headerName: 'Descripción',
      sortable: true,
      wrapText: true,
      autoHeight: true
    },
    {
      field: 'dinNumeric3',
      headerName: 'Cantidad',
      cellStyle: { textAlign: "center" },
      maxWidth: 100,
      minWidth: 100,
      sortable: false
    },
    {
      colId: 'stock',
      field: 'stock',
      headerName: 'Stock',
      maxWidth: 70,
      minWidth: 70,
      cellStyle: { textAlign: "center" }
    },
    {
      colId: 'id',
      field: 'id',
      headerName: 'Folio',
      maxWidth: 80,
      minWidth: 80,
      autoHeight: true,
      cellRenderer: customFolio,
      cellStyle: { textAlign: "center" }
    },
    {
      field: 'quotation.currentDate',
      headerName: 'Fecha Pedido',
      sortable: true,
      type: 'date',
      cellStyle: { textAlign: "center" },
      getQuickFilterText: params => {
        return params.data.quotation.currentDate;
      }
    },
    {
      field: 'deliveryDate',
      headerName: 'Fecha Requerida',
      type: 'date',
      sortable: true,
      cellRenderer: customFechaRequerida,
      cellStyle: { textAlign: "center" },
      getQuickFilterText: params => {
        return params.data.deliveryDate;
      }
    },
    {
      colId: 'sellerName',
      field: 'sellerName',
      headerName: 'Cliente',
      sortable: true,
      wrapText: true,
      autoHeight: true
    },
    {
      field: 'scan',
      headerName: 'Escanear',
      cellRenderer: customScan,
      cellStyle: { textAlign: "center" },
      maxWidth: 100,
      minWidth: 100,
    }
  ]

  function customTypeHeader(data) {
    return (
      <div style={{ alignItems: 'center', display: 'flex' }}>
        <Tooltip
          visible={tooltipVisible}
          placement="right"
          animation="zoom"
          onVisibleChange={changeTooltipVisible}
          trigger="click"
          overlay={
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}><ShoppingBasketIcon style={{ marginRight: 4 }} />Pedido de Venta</div>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}><FolderIcon style={{ marginRight: 4 }} />Reporte de Consumo</div>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}><DescriptionIcon style={{ marginRight: 4 }} />Prestamo</div>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}><SyncIcon style={{ marginRight: 4 }} />Consigna</div>
            </div>
          }
        >
          <InfoIcon onClick={changeTooltipVisible} style={{ color: '#484f59' }} />
        </Tooltip>
        {data.displayName} {/* Muestra el nombre de la columna */}
      </div>
    );
  }
  function customType(data) {
    return (
      <div style={{
        marginTop: 8
      }}>
        <ShoppingBasketIcon style={{ color: '#484f59' }} />
      </div>
    )
  }
  function customFolio(data) {
    return (
      <p onClick={() => { handleGetAllInfo([data.data]) }} style={{ color: 'black', fontWeight: 'bold', textDecoration: 'underline' }}>{data.value}</p>
    )
  }
  function customProdCode(data) {
    return (
      <p onClick={() => { handleGetAllInfo([data.data]) }} style={{ color: 'black', fontWeight: 'bold', textDecoration: 'underline' }}>{data.value}</p>
    )
  }
  function customFechaRequerida(data) {
    const date = formatearFecha(data)
    const overdue = isOverdue(data)

    return (
      <p style={{
        color: overdue ? 'red' : 'black'
      }}>{date}</p>
    )
  }
  function customScan(data) {
    return (
      <div style={{
        marginTop: 8
      }}>
        <CropFreeIcon style={{ color: '#484f59' }} onClick={handleOpenModalScan} />
      </div>
    )
  }

  const columnTypes = useMemo(() => {
    return {
      date: {
        valueFormatter: formatearFecha,
      }
    };
  }, []);

  const autoSizeStrategy = {
    type: 'fitGridWidth',
    defaultMinWidth: 100,
  };

  function changeTooltipVisible() {
    setTooltipVisible(!tooltipVisible)
  }

  function formatearFecha(data) {
    if (data && data.value) {
      const fecha = new Date(data.value);

      const formatter = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      let fechaFinal = formatter.format(fecha).replace(" de ", "/").replace(" de ", "/");
      return fechaFinal;
    }
  }

  function isOverdue(data) {
    if (data && data.value) {
      const fecha = new Date(data.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to midnight to compare only dates

      return fecha <= today;
    }
    return false;
  }

  const handleGetAllInfo = async (orders) => {
    console.log('ORDER: ', orders)
    props.setLoading(true)
    let ordersRemissions = []
    for (const element of orders) {
      await getRemissionsByOrderAsync(element.id, requestH).then(async (data) => {
        if (data.response && data.response.length > 0 && data.response[0].remissions) {
          const remissionData = data.response[0]
          const arrayRemissions = returnRemissionsArray(data.response[0].remissions)
          if (arrayRemissions && arrayRemissions.length > 0) {
            const allRemissionsDetail = []
            for (const singleRemission of arrayRemissions) {
              /* await getRemissionDetailAsync(singleRemission, requestH).then((dataDetail) => {
                allRemissionsDetail.push(dataDetail.response)
              }) */
            }
            remissionData.details = allRemissionsDetail
            remissionData.orderId = element.id
            ordersRemissions.push(remissionData)
          }
        }
      })
    }
    props.setLoading(false)
    history.push({
      pathname: "/orderDetailsNew",
      state: {
        order: orders[0],
        remissionInformation: formatArray(ordersRemissions)[0]
      }
    });
  }

  function returnRemissionsArray(cadena) {
    const numeros = cadena.split(',').map(item => parseInt(item.trim()));
    return numeros;
  }

  function formatArray(arr) {
    return arr.map((item) => {
      const details = item.details.flat();
      const shipmentsQuantity = details.length;

      let generalQuantity = 0;
      details.forEach((detail) => {
        generalQuantity += detail.quantity;
      });

      return {
        ...item,
        details,
        shipmentsQuantity,
        generalQuantity
      };
    });
  }

  const [openToastyError, setOpenToastyError] = React.useState(false);
  const [openModalScan, setOpenModalScan] = React.useState(false);
  const [scanLineCode, setScanLineCode] = useState('')
  const [inputValueAlmacen, setInputValueAlmacen] = React.useState('');
  const [inputValueLocation, setInputValueLocation] = React.useState('');
  const [valueAlmacen, setValueAlmacen] = React.useState('');
  const [almacenList, setAlmacenList] = useState([])
  const [valueLocation, setValueLocation] = React.useState('');
  const [locationList, setLocationList] = useState([])
  const [rowsScan, setRowsScan] = useState([]);
  const [openModalManualScan, setOpenModalManualScan] = React.useState(false);

  const handleCloseModalScan = () => {
    setOpenModalScan(false);
  }

  const handleAddAutomatic = (scanLine, almacen, localizacion) => {
    if (scanLine)
      setScanLineCode(scanLine.target.value)
    else if (almacen)
      handleInputValueAlmacen(almacen)
    else if (localizacion)
      handleInputValueLocation(localizacion)
  }

  const handleInputValueAlmacen = (value) => {
    setInputValueAlmacen(value)
  }

  const handleInputValueLocation = (value) => {
    setInputValueLocation(value)
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleAddToArrayAtomatic()
    }
  };

  const handleAddToArrayAtomatic = () => {
    if (scanLineCode && valueAlmacen && valueLocation) {
      const cadenaProcesada = procesarCadena(scanLineCode)
      if (cadenaProcesada != 'La cadena no cumple con el formato requerido') {
        setScanLineCode('')
        const pedimentoProcesado = esFechaValida(cadenaProcesada[2])
        if (pedimentoProcesado) {
          addToPreRemissionAutomatic(cadenaProcesada[0], cadenaProcesada[1])
        } else {
          addToPreRemissionAutomatic(cadenaProcesada[0], cadenaProcesada[1], cadenaProcesada[2])
        }
      }
    }
  }

  function procesarCadena(cadena) {
    let separador = "|";
    let inicio = "@";
    let inicio2 = "";

    if (cadena.startsWith(inicio)) {
      let temporalString = reemplazarCaracteres(cadena);
      return temporalString.slice(1).split(separador);
    } else if (cadena.startsWith(inicio2)) {
      let temporalString = reemplazarCaracteres(cadena);
      return temporalString.slice(0).split(separador);
    } else {
      setOpenToastyError(true)
      return "La cadena no cumple con el formato requerido";
    }
  }

  function reemplazarCaracteres(string) {
    return string.replace(/]/g, "|");
  }

  const getWarehouse = async () => {
    await getWarehouseAsync(requestH).then((data) => {
      setAlmacenList(data.response)
    })
  }

  const getLocations = async () => {
    await getLocationsAsync(requestH).then((data) => {
      setLocationList(data.response)
    }).catch((e) => { console.log(e) })
  }

  const columnsEscanear = [
    { id: 'codigo', label: 'Codigo', minWidth: 100 },
    { id: 'cantidad', label: 'Cantidad', minWidth: 100 },
    { id: 'lote', label: 'Lote', minWidth: 100 },
    { id: 'pedimento', label: 'Pedimento', minWidth: 170 },
    { id: 'almacen', label: 'Almacen', minWidth: 170 },
    { id: 'ubicacion', label: 'Ubicacion', minWidth: 170, },
    { id: 'borrar', label: '', minWidth: 170, },
  ];

  const removeFromPreRemission = (index) => {
    const temporalCart = structuredClone(rowsScan)
    const resultArray = removeItemByIndex(temporalCart, index)
    setRowsScan(resultArray)
  }

  function removeItemByIndex(array, index) {
    if (index > -1 && index < array.length) {
      array.splice(index, 1);
    }
    return array;
  }

  const handleCloseModalManualScan = () => {
    setOpenModalManualScan(false);
  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleOpenModalScan = () => {
    setOpenModalScan(true);
  };

  useEffect(() => {
    getWarehouse()
    getLocations()
  }, [])

  return (
    <div style={{ height: '85%' }}>
      <Snackbar
        open={openToastyError}
        onClose={() => { setOpenToastyError(false) }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="error"
      >
        <Alert severity="error">
          {`La cadena no cumple con el formato requerido`}
        </Alert>
      </Snackbar>
      <div className="ag-theme-quartz" style={{ height: '95%', margin: 10 }}>
        {!props.loading &&
          <AgGridReact
            ref={gridRef}
            rowData={props.products}
            localeText={AG_GRID_LOCALE_ES}
            columnDefs={columns}
            suppressMovableColumns
            columnTypes={columnTypes}
            autoSizeStrategy={autoSizeStrategy}
            pagination={pagination}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
            quickFilterText={props.searchedValuesGeneral}
          />
        }
      </div>
      {/* Captura Automatica */}
      <Dialog
        open={openModalScan}
        onClose={handleCloseModalScan}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth='xl'
      >
        <DialogTitle id="form-dialog-title">
          <div style={{ display: 'flex', marginBottom: 40 }}>
            <p style={{ marginRight: 30, fontWeight: 'bold' }}>Escanear</p>
          </div>
        </DialogTitle>
        <div style={{ display: 'flex', marginLeft: '100px', marginBottom: '20px', flexDirection: 'column', marginRight: '100px', fontFamily: 'arial' }}>
          <div style={{ width: '100%' }}>
            <TextField
              id="outlined-basic"
              label="Línea de captura de escaneo"
              variant="outlined"
              style={{ width: '100%' }}
              defaultValue={scanLineCode}
              value={scanLineCode}
              onChange={(e) => { handleAddAutomatic(e, null, null); }}
              onKeyDown={handleKeyDown}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
            <Autocomplete
              value={valueAlmacen}
              onChange={(event, newValue) => { setValueAlmacen(newValue) }}
              inputValue={inputValueAlmacen}
              onInputChange={(event, newInputValue) => { handleAddAutomatic(null, newInputValue, null) }}
              id="controllable-states-demo"
              options={almacenList}
              getOptionLabel={(option) => option ? `${option.name}` : 'Almacen'}
              style={{ width: '49%' }}
              renderInput={(params) => <TextField {...params} label="Almacen" variant="outlined" />}
            />
            <Autocomplete
              value={valueLocation}
              onChange={(event, newValue) => { setValueLocation(newValue) }}
              inputValue={inputValueLocation}
              onInputChange={(event, newInputValue) => { handleAddAutomatic(null, null, newInputValue) }}
              id="controllable-states-demo"
              options={locationList}
              getOptionLabel={(option) => option ? `${option.name}` : 'Ubicación'}
              style={{ width: '49%' }}
              renderInput={(params) => <TextField {...params} label="Ubicación" variant="outlined" />}
            />
          </div>
          {rowsScan && rowsScan.length > 0 &&
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
              <TableContainer className={classes.container} style={{ maxHeight: 600 }}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      {columnsEscanear.map((column) => {
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            <div style={{ display: 'flex' }}>
                              {column.label}
                            </div>
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowsScan && rowsScan.map((row, index) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                          {columnsEscanear.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {column.id == 'codigo' && row.product.productCode}
                                {column.id == 'cantidad' && <TextField id="outlined-basic" variant="outlined" value={row.quantity} />}
                                {column.id == 'lote' && row.lote}
                                {column.id == 'pedimento' && row.pedimento}
                                {column.id == 'almacen' && row.locationStorage.name}
                                {column.id == 'ubicacion' && row.location.name}
                                {column.id == 'borrar' && < DeleteIcon style={{ color: 'red' }} onClick={() => { removeFromPreRemission(index) }} />}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          }
        </div>
        <DialogContent style={{ display: 'flex', marginLeft: '100px', marginBottom: '20px', flexDirection: 'row', marginRight: '100px', fontFamily: 'arial' }}>
          {/* <div style={{ width: '50%' }}>
            <button className="btn" style={{ width: 250, fontFamily: 'arial', fontWeight: 'bold' }} onClick={() => {
              setOpenModalManualScan(true)
              setOpenModalScan(false)
            }}>CAPTURA MANUAL</button>
          </div> */}
          <div style={{ width: '50%', display: 'flex', justifyContent: 'end' }}>
            <button className="btn" style={{ width: 250, fontFamily: 'arial', fontWeight: 'bold' }}>GENERAR REMISIÓN</button>
          </div>
        </DialogContent>
        <DialogActions style={{ marginTop: 100 }}>
        </DialogActions>
      </Dialog>

      {/* Captura Manual */}
      {/* <Dialog
        open={openModalManualScan}
        onClose={handleCloseModalManualScan}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth='xl'
      >
        <DialogTitle id="form-dialog-title"><div style={{ display: 'flex', marginBottom: 40 }}>
          <p style={{ marginRight: 30, fontWeight: 'bold' }}>Captura Manual</p>
        </div></DialogTitle>
        <div style={{ display: 'flex', marginLeft: '100px', marginBottom: '20px', flexDirection: 'column', marginRight: '100px', fontFamily: 'arial' }}>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <TextField id="outlined-basic" label="Código de Producto" variant="outlined" style={{ width: '32%' }} value={productCode} onChange={(e) => { setProductCode(e.target.value) }} error={true} />
            <TextField id="outlined-basic" label="Lote" variant="outlined" style={{ width: '32%' }} value={lote} onChange={(e) => { setLote(e.target.value) }} />
            <TextField id="outlined-basic" label="Pedimento" variant="outlined" style={{ width: '32%' }} value={pedimento} onChange={(e) => { setPedimento(e.target.value) }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
            <Autocomplete
              value={valueAlmacen}
              onChange={(event, newValue) => { setValueAlmacen(newValue) }}
              inputValue={inputValueAlmacen}
              onInputChange={(event, newInputValue) => { handleInputValueAlmacen(newInputValue) }}
              id="controllable-states-demo"
              options={almacenList}
              getOptionLabel={(option) => option ? `${option.name}` : 'Almacen'}
              style={{ width: '32%' }}
              renderInput={(params) => <TextField {...params} label="Almacen" variant="outlined" />}
            />
            <Autocomplete
              value={valueLocation}
              onChange={(event, newValue) => { setValueLocation(newValue) }}
              inputValue={inputValueLocation}
              onInputChange={(event, newInputValue) => { handleInputValueLocation(newInputValue) }}
              id="controllable-states-demo"
              options={locationList}
              getOptionLabel={(option) => option ? `${option.name}` : 'Ubicación'}
              style={{ width: '32%' }}
              renderInput={(params) => <TextField {...params} label="Ubicación" variant="outlined" />}
            />
            <div style={{ width: '32%' }}>
              <button className="btn" style={{ width: 220, fontFamily: 'arial', fontWeight: 'bold' }} onClick={addToPreRemission}>AGREGAR</button>
            </div>

          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
            <TableContainer className={classes.container} style={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    {columnsEscanear.map((column) => {
                      const id = column.id
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          <div style={{ display: 'flex' }}>
                            {column.label}
                          </div>
                        </TableCell>
                      )
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsScan && rowsScan.map((row, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                        {columnsEscanear.map((column) => {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.id == 'codigo' && row.product.productCode}
                              {column.id == 'cantidad' && <TextField id="outlined-basic" variant="outlined" value={row.quantity} />}
                              {column.id == 'lote' && row.lote}
                              {column.id == 'pedimento' && row.pedimento}
                              {column.id == 'almacen' && row.locationStorage.name}
                              {column.id == 'ubicacion' && row.location.name}
                              {column.id == 'borrar' && < DeleteIcon style={{ color: 'red' }} onClick={() => { removeFromPreRemission(index) }} />}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <DialogContent style={{ display: 'flex', marginLeft: '100px', marginBottom: '20px', flexDirection: 'row', marginRight: '100px', fontFamily: 'arial' }}>
          <div style={{ width: '50%' }}>
            <button className="btn" style={{ width: 250, fontFamily: 'arial', fontWeight: 'bold' }} onClick={() => {
              setOpenModalManualScan(false)
              setOpenModalScan(true)
            }}>CAPTURA AUTOMATICA</button>
          </div>
          <div style={{ width: '50%', display: 'flex', justifyContent: 'end' }}>
            <button className="btn" style={{ width: 250, fontFamily: 'arial', fontWeight: 'bold' }} onClick={addRemision}>ENVIAR A REMISIÓN</button>
          </div>
        </DialogContent>
        <DialogActions style={{ marginTop: 100 }}>
        </DialogActions>
      </Dialog> */}
    </div>
  )

}

export const OrderList = (props) => {
  const { searchQuoteFinished } = useParams();
  const { setNavbarStyle } = useNavbar();
  const requestH = useSelector((state) => state.user.request);

  const [loading, setLoading] = useState(true)
  const [inputValue, setInputValue] = React.useState('productos');
  const [searchedValuesGeneral, setSearchedValuesGeneral] = useState("");
  const [orders, setOrders] = useState([])
  const [products, setProducts] = useState([])

  const handleInputChange = (event) => {
    setSearchedValuesGeneral('')
    setInputValue(event.target.value);
  };

  function formatearFecha(data) {
    if (data) {
      const fecha = new Date(data);

      const formatter = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      let fechaFinal = formatter.format(fecha).replace(" de ", "/").replace(" de ", "/");
      return fechaFinal;
    }
  }

  const formatDates = (data) => {
    if (data && data.length > 0) {
      const newArray = data.map((singleElement) => {
        const requiredDate = formatearFecha(singleElement.deliveryDate)
        singleElement.requiredDate = requiredDate
        return singleElement
      })
      return newArray
    } else {
      return []
    }
  }

  const getAllOrdersFunction = async () => {
    await getAllOrders(requestH).then((data) => {
      const formattedData = formatDates(data.response)
      setOrders(formattedData)
      setLoading(false)
    })
  }

  const getAllProductsFunction = async () => {
    await GetOrdersProductAsync(0, requestH).then((data) => {
      setProducts(data.response)
      props.setLoading(false)
    })
  }

  useEffect(() => {
    setNavbarStyle({ position: "relative", top: "auto" });
    return () => setNavbarStyle({});
  }, []);

  useEffect(() => {
    getAllOrdersFunction()
    getAllProductsFunction()
  }, [])

  return (
    <>
      <SubNavBarComponent
        searchActive={false}
        typeSearch={'none'}
        specificType={'listaPrecios'}
        historyPage={searchQuoteFinished && `/cotizaciones_finalizadas`}
        title={inputValue == 'productos' ? `PRODUCTOS` : 'PEDIDOS'}
      />
      <div style={{
        height: '82vh',
        marginTop: '7vh'
      }}>

        {/* Options Bar */}
        {!loading &&
          <div style={{
            background: '#F0F0F0',
            display: 'flex',
            height: '15%',
            width: '100%',
            alignItems: 'center'
          }}>
            <div style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
              <div style={{ paddingLeft: 40 }}>
                <p style={{ fontFamily: 'arial', fontSize: '20px', fontWeight: 'bold' }}>Filtro</p>
              </div>
              <div style={{ width: '40%', paddingLeft: 40 }}>
                <FormControl variant="outlined" style={{
                  width: '100%',
                  height: '46px',
                  boxSizing: 'border-box',
                  background: '#FFFFFF',
                  border: '1px solid rgba(0, 0, 0, 0.5)',
                  borderRadius: '4px'
                }}>
                  <InputLabel id="demo-simple-select-outlined-label">
                    Mostrar por
                  </InputLabel>
                  <Select
                    style={{
                      height: '46px',
                    }}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    labelWidth={'Tipo de Generador'}
                    value={inputValue}
                    onChange={handleInputChange}
                  >
                    <MenuItem value={'productos'}>Backorder</MenuItem>
                    <MenuItem value={'pedidos'}>Pedidos</MenuItem>
                  </Select>
                </FormControl>            </div>
            </div>
            <div style={{ display: 'flex', width: '50%', justifyContent: 'flex-end', paddingRight: 40 }}>
              <SearchBar
                value={searchedValuesGeneral}
                onChange={(searchVal) => { setSearchedValuesGeneral(searchVal) }}
                onCancelSearch={() => setSearchedValuesGeneral(null)}
                placeholder={'Buscar'}
                style={{
                  width: '40%',
                  height: '46px',
                  boxSizing: 'border-box',
                  background: '#FFFFFF',
                  border: '1px solid rgba(0, 0, 0, 0.5)',
                  borderRadius: '4px',
                }}
              />
            </div>
          </div>
        }

        {/* Loading Spinner */}
        {loading &&
          <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: 100 }}>
            <CircularProgress color="secondary" />
          </div>
        }

        {inputValue == 'pedidos' &&
          <OrderListOrders
            loading={loading}
            setLoading={setLoading}
            searchedValuesGeneral={searchedValuesGeneral}
            orders={orders}
          />
        }

        {inputValue == 'productos' &&
          <OrderListProducts
            loading={loading}
            setLoading={setLoading}
            searchedValuesGeneral={searchedValuesGeneral}
            orders={orders}
            products={products}
          />
        }


      </div>
    </>
  );
};
